import React, { useEffect } from "react";
import Navibar from "../components/Navibar";
import Footer from "../components/Footer";
import baguetteBox from "baguettebox.js"; // Import baguetteBox
import "baguettebox.js/dist/baguetteBox.min.css"; // Import CSS

import Certifications from "../components/Certifications";

export default function Fabrics() {
  // Reusable FabricCard Component

  const FabricCard = ({ imgSrc, altText, description }) => {
    return (
      <div className="col-sm-6 col-md-4 pb-3">
        <a
          className="lightbox wow zoomIn  bg-dark"
          href={imgSrc}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "300px",
            height: "300px",
            overflow: "hidden",
          }}
        >
          <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
            <img
              src={imgSrc}
              alt={altText}
              style={{
                width: "100%",
                height: "inherit",
                maxHeight: "100%",
                objectFit: "fill",
              }}
            />
          </div>
          <p>{description}</p>
        </a>
      </div>
    );
  };
  // Fabric data
  const fabrics = [
    {
      imgSrc: "/img/Products/tote/tote1.png",
      altText: "Bridge",
      description: "Tote bags",
    },
    {
      imgSrc: "/img/Products/tote/tote2.png",
      altText: "Park",
      description: "Beach bags",
    },
    {
      imgSrc: "/img/Products/tote/tote3.png",
      altText: "Tunnel",
      description: "Multipurpose bags",
    },
    {
      imgSrc: "/img/Products/tote/tote4.png",
      altText: "Traffic",
      description: "Recycled Vegetable bags",
    },
    {
      imgSrc: "/img/Products/tote/tote5.png",
      altText: "Coast",
      description: "Mesh Bags",
    },
    {
      imgSrc: "/img/Products/tote/tote6.png",
      altText: "Rails",
      description: "Shopping bags",
    },
    {
      imgSrc: "/img/Products/tote/tote7.png",
      altText: "Rails",
      description: "Vegetable Pouches",
    },
    {
      imgSrc: "/img/Products/tote/tote8.png",
      altText: "Rails",
      description: "Shopping bags",
    },
    {
      imgSrc: "/img/Products/tote/tote9.png",
      altText: "Rails",
      description: "Tote bags",
    },
  ];

  useEffect(() => {
    baguetteBox.run(".tz-gallery");
  }, []); // Run only once after the component mounts

  return (
    <>
      <Navibar />
      <div className="page-title-area">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <h2>Bags</h2>
              <p>
                Our collection of tote and mesh bags combines functionality with
                style, ideal for everyday use or special outings. Crafted with
                durable materials, these versatile bags are perfect for carrying
                essentials while adding a fashionable touch to any ensemble.
              </p>
              <div className="d-flex justify-content-around">
                <p className="text-bullet">
                  <li> Tote Bags</li>
                  <li> Reusable Grocery Bags</li>
                </p>
                <p className="text-bullet">
                  {" "}
                  <li> Mesh Bags</li>
                  <li> Beach Bags</li>
                </p>
                <p className="text-bullet">
                  <li> Recycled Bags</li>
                  <li> Shopping Bags</li>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tz-gallery">
        <div className="row">
          {fabrics.map((fabric, index) => (
            <FabricCard
              key={index} // Use index but ideally use a unique id
              imgSrc={fabric.imgSrc}
              altText={fabric.altText}
              description={fabric.description}
            />
          ))}
        </div>
      </div>

      <Certifications />
      <Footer />
    </>
  );
}
